import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import * as d3 from 'd3';

@Component({
    selector: 'lib-line-chart-filled',
    templateUrl: './line-chart-filled.component.html',
    styleUrls: ['./line-chart-filled.component.scss']
})
export class LineChartFilledComponent implements OnInit, OnChanges {
    @Input() activeZoneIndex = 1;
    @Input() xAxisText = 'Anxiety';
    @Input() data: {
        segments: any[],
        labels: string[],
        data: [][]
    } = {
        segments: [],
        labels: [],
        data: []
    };
    @Input() id = 1;
    curveData: any[] = [];
    @ViewChild('area') area: ElementRef = new ElementRef<any>(null);

    segmentGradient = ['#FFF847', '#14FF80', '#FF5757'];
    chartId = Math.round(+(Math.random() * 100000).toFixed() * +(Math.random() * 100000).toFixed() / +(Math.random() * 100000).toFixed());

    constructor(
        private container: ElementRef
    ) {
    }

    ngOnInit(): void {
        // tslint:disable-next-line:max-line-length
        const curvePoints = [[2, 189.92599487304688], [7.360604763031006, 189.63827514648438], [12.657036781311035, 188.763671875], [17.823932647705078, 187.3073272705078], [22.80470848083496, 185.30421447753906], [27.559694290161133, 182.8112335205078], [32.06880569458008, 179.896240234375], [36.32911682128906, 176.62774658203125], [40.34987258911133, 173.06820678710938], [44.14745330810547, 169.2711181640625], [47.741634368896484, 165.28073120117188], [51.15338134765625, 161.1331024169922], [54.4029541015625, 156.85708618164062], [57.50916290283203, 152.47573852539062], [60.489437103271484, 148.00772094726562], [63.35979461669922, 143.46824645996094], [66.13414764404297, 138.86940002441406], [68.82581329345703, 134.2216796875], [71.44645690917969, 129.5335235595703], [74.00678253173828, 124.81214141845703], [76.51724243164062, 120.06404876708984], [78.98648071289062, 115.29437255859375], [81.42362213134766, 110.50821685791016], [83.83644104003906, 105.70974731445312], [86.23381805419922, 100.90353393554688], [88.62285614013672, 96.09318542480469], [91.01133728027344, 91.28254699707031], [93.40705108642578, 86.47549438476562], [95.8176040649414, 81.67589569091797], [98.25035858154297, 76.88748168945312], [100.71450805664062, 72.11517333984375], [103.21868133544922, 67.36375427246094], [105.7716064453125, 62.63837432861328], [108.38349151611328, 57.945350646972656], [111.06522369384766, 53.29191589355469], [113.82858276367188, 48.68647003173828], [116.68626403808594, 44.13900375366211], [119.65290832519531, 39.66189956665039], [122.74420166015625, 35.27001953125], [125.9775619506836, 30.981691360473633], [129.3723907470703, 26.8201904296875], [132.9486541748047, 22.81372833251953], [136.72801208496094, 18.998476028442383], [140.73074340820312, 15.418680191040039], [144.97401428222656, 12.128094673156738], [149.46807861328125, 9.189981460571289], [154.21087646484375, 6.673973560333252], [159.18309020996094, 4.6497697830200195], [164.34523010253906, 3.1766960620880127], [169.63973999023438, 2.291363000869751], [175, 2], [180.36033630371094, 2.291372776031494], [185.65487670898438, 3.176722288131714], [190.8170166015625, 4.649808883666992], [195.7892303466797, 6.67402458190918], [200.53201293945312, 9.190033912658691], [205.0260772705078, 12.128159523010254], [209.2693634033203, 15.418777465820312], [213.27207946777344, 18.99858856201172], [217.05140686035156, 22.813823699951172], [220.627685546875, 26.820266723632812], [224.0225067138672, 30.981773376464844], [227.255859375, 35.27008056640625], [230.34715270996094, 39.66196060180664], [233.31378173828125, 44.139068603515625], [236.17144775390625, 48.6865348815918], [238.9347381591797, 53.29198455810547], [241.61619567871094, 57.94561767578125], [244.2284393310547, 62.63845443725586], [246.78138732910156, 67.3638687133789], [249.28555297851562, 72.11524963378906], [251.74923706054688, 76.88777160644531], [254.18243408203125, 81.67595672607422], [256.593017578125, 86.47557830810547], [258.98858642578125, 91.28267669677734], [261.3771667480469, 96.09324645996094], [263.7662048339844, 100.90360260009766], [266.1636047363281, 105.70983123779297], [268.5768737792969, 110.50808715820312], [271.0135498046875, 115.2944564819336], [273.4828186035156, 120.0641098022461], [275.9932861328125, 124.81220245361328], [278.5535888671875, 129.5336151123047], [281.17449951171875, 134.2216033935547], [283.8661804199219, 138.8693084716797], [286.6402282714844, 143.46829223632812], [289.5105895996094, 148.0077667236328], [292.4908752441406, 152.47579956054688], [295.5970764160156, 156.85714721679688], [298.8466491699219, 161.13314819335938], [302.2583923339844, 165.28077697753906], [305.852783203125, 169.27096557617188], [309.6503601074219, 173.06802368164062], [313.67095947265625, 176.6277618408203], [317.9313049316406, 179.8962860107422], [322.4403991699219, 182.81129455566406], [327.1954040527344, 185.30426025390625], [332.1761474609375, 187.30735778808594], [337.34307861328125, 188.76370239257812], [342.6394958496094, 189.63829040527344]];
        curvePoints.forEach((el) => {
            this.curveData.push({
                x: el[0],
                y: el[1]
            });
        });

        this.draw(this.data.data, this.data.segments);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.data && !changes.data.firstChange) {
            this.draw(changes.data.currentValue.data, changes.data.currentValue.segments);
        }
    }

    // ngAfterViewInit() {
    //     this.draw(this.data, this.value, this.areas);
    // }

    draw(data: any, areas: any) {
        data = data
            .map((el: any, i: number) => {
                const dataEl: any = {
                    x: el.x,
                    y: el.y,
                };
                areas
                    .forEach((area: number[], k: number) => {
                        dataEl[`area_${k + 1}`] = area[0] <= i && i <= area[1] ? el.y : 0;
                    });
                return dataEl;
            });
        data = data.sort((aa: any, bb: any) => aa.x - bb.x);
        const margin = {top: 30, right: 20, bottom: 40, left: 30};
        const width = 350 - margin.left - margin.right;
        const height = 200 - margin.top - margin.bottom;

        const x: any = d3.scaleLinear()
            .domain([0, d3.max(data, (d: any) => d.x as number) as number])
            .range([0, width]);

        const y: any = d3.scaleLinear()
            .domain([0, d3.max(data, (d: any) => d.y as number) as number])
            .range([height, 0]);


        const line: any = d3.line()
            .x((d: any) => x(d.x))
            .y((d: any) => y(d.y));

        const xscale = d3.scaleLinear()
            .domain([0, 100])
            .range([0, width]);

        const scale: any = d3.scaleLinear()
            .domain([d3.min(data, (el: any) => el.x as number) as number, d3.max(data, (el: any) => el.y as number) as number])
            .range([height, 0]);

        const yAxis: any = d3.axisLeft(scale)
            .tickSize(0)
            .ticks(0)
            .tickSize(0)
            .scale(scale);
        //
        // const xAxis: any = d3.axisBottom(scale)
        //     .ticks(3)
        //     .tickSize(0)
        //     .tickFormat((d: any) => {
        //         return '1';
        //     })
        //     .scale(scale);


        const w = d3.select(this.container.nativeElement).select('div.lineWrapper');
        w.select('svg').remove();
        // w.append('svg')
        //     .attr('id', 'areaChart' + this.chartId);
        const svg: any = w.append('svg')
            .attr('id', 'areaChart' + this.chartId)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .attr('viewBox', [0, 0, width + margin.left + margin.right, height + margin.top + margin.bottom])
            .attr('style', 'max-width: 100%; height: auto;')
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        svg.attr('preserveAspectRatio', 'xMinYMin meet')
            .attr('viewBox', `0 0 ${width} ${height}`)
            .classed('svg-content-responsive', true);

        const createRadialGradient: any = (select: any) => {
            const gradient = select
                .select('defs');
            gradient
                .append('linearGradient')
                .attr('id', 'sun-gradient' + this.chartId)
                .attr('cx', '100%')    // not really needed, since 50% is the default
                .attr('cy', '100%')    // not really needed, since 50% is the default
                .selectAll('stop')
                .data([
                    {offset: '0%', color: this.segmentGradient[0]},
                    {offset: '100%', color: this.segmentGradient[2]},
                ])
                .enter().append('stop')
                .attr('offset', (d: any) => d.offset)
                .attr('stop-color', (d: any) => d.color);
        };
        svg.append('defs');
        svg.call(createRadialGradient);


        svg.append('g')
            .attr('transform', 'translate(0, 0)')
            .style('color', '#10082F')
            .style('stroke-width', '1px')
            .call(yAxis);


        svg.append('g')
            .attr('class', 'x axis')
            .style('stroke-width', '1px')
            .style('color', '#10082F')
            .attr('transform', 'translate(0,' + height + ')') // Move the axis to the bottom
            .call(d3.axisBottom(xscale)
                .ticks(0)
                .tickSize(0))
            .append('line')
            .attr('x1', '100%');


        const activeArea = this.activeZone();

        areas.forEach((areaInterval: any, k: any) => {
            const isActive = activeArea === k;
            const area = d3.area()
                .x((d: any) => x(d.x))
                .y0(height - 1)
                .y1((d: any) => y(d[`area_${k + 1}`]));
            const areaData = data.filter((el: any) => el[`area_${k + 1}`] > 0);
            svg.append('path')
                .datum(areaData)
                .attr('class', 'area')
                .attr('id', 'p' + k)
                .style('stroke-width', '0')
                .style('fill', isActive ? `url(#sun-gradient${this.chartId})` : 'transparent')
                .attr('d', area);
            svg.append('text')
                .attr('x', (areaInterval[0] + (areaInterval[1] - areaInterval[0]) / 2) / 100 * width - 6)
                .attr('y', height - 13)
                .attr('font-family', 'Raleway')
                .attr('font-size', '10px')
                .text(this.data?.labels[k] || '*');

            if (areaInterval[0] > 0) {
                svg.append('text')
                    .attr('x', areaInterval[0] / 100 * width - 5)
                    .attr('y', height + 20)
                    .attr('font-family', 'Raleway')
                    .attr('font-size', '10px')
                    .text(areaInterval[0]);
                svg.append('rect')
                    .attr('width', 2)
                    .attr('height', 10)
                    .attr('x', areaInterval[0] / 100 * width)
                    // .attr('x', (1 + areaInterval[0] + (areaInterval[1] - areaInterval[0]) / 2) / 100 * width)
                    .attr('y', height)
                    .attr('fill', `#10082F`);
            }

        });

        svg.append('path')
            .datum(data)
            .attr('class', 'line')
            .style('stroke', '#10082F')
            .style('stroke-width', '2px')
            .style('stroke-linecap', 'butt')
            .style('fill', 'none')
            .attr('d', line);

        // svg.append('circle')
        //     .attr('cx', points[this.value].x)
        //     .attr('cy', points[this.value].y)
        //     .attr('r', '10px')
        //     .style('fill', '#f9f9f9')
        //     .style('stroke', '#805FFF')
        //     .style('stroke-width', '3px');

        const textX = svg.append('text');
        textX
            .attr('y', height + 12)
            .attr('x', (): any => 0)
            .attr('font-weight', '300')
            .attr('font-size', '14')
            .attr('dy', '12px')
            .style('fill', '#10082F')
            .text((): any => this.xAxisText);

        svg.append('text')
            .attr('class', 'y label')
            .attr('text-anchor', 'start')
            .attr('x', -height)
            .attr('y', -25)
            .attr('dy', '.75em')
            .attr('font-weight', '300')
            .style('fill', '#10082F')
            .attr('font-size', '14')
            .attr('dy', '12px')
            .attr('transform', 'rotate(-90)')
            .text('% of employees');
    }

    activeZone() {
        // return data.findIndex((areaInterval: any[]) => areaInterval[0] < value && value <= areaInterval[1]);
        return this.activeZoneIndex - 1;

    }

}
